export { pluginTs, pluginTsName } from './plugin.ts'
export type { PluginTs } from './types.ts'
